// All atom functions are placed here
// Close
const buttonClose = document.querySelectorAll('.js-close')
buttonClose.forEach(function(entry) {
  entry.addEventListener('click', e => {
    e.preventDefault()
    document.querySelector('.visible').classList.remove('visible')
    document.querySelector('body').style.overflow = null // To reset body scrolling in the background
  })
})
